import { withApollo } from "react-apollo";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";
import { styles } from "./styles.js";
import Notificaciones from "./Notificaciones";

const enhance = compose(
  withApollo,
  withRouter,
  withStyles(styles)
);

export default enhance(Notificaciones);
